import styled from '@emotion/styled'
import AutorenewIcon from '@mui/icons-material/Autorenew'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { Typography } from '@mui/material'

const PaddedText = styled(Typography)`
	${({ theme }) => `
		color: ${theme.palette.text.secondary};
    `}
	padding-right: 8px;
`

const StyledSavingIcon = styled(AutorenewIcon)`
	${({ theme }) => `
		color: ${theme.palette.icons.secondary};
	`}
`

const StyledSavedIcon = styled(CheckCircleOutlineIcon)`
	${({ theme }) => `
		color: ${theme.palette.icons.secondary};
	`}
`

export { PaddedText, StyledSavedIcon, StyledSavingIcon }
